// extracted by mini-css-extract-plugin
export default {"link":"zK-z","disabled":"AK-z"};